import { createActions, createReducer } from 'reduxsauce'

import DetalhesRecursoConcedidoService from '../../servicos/DetalhesRecursoConcedidoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConvenentesConcedentesConcedidoInicio: [],
    buscaConvenentesConcedentesConcedidoSucesso: ['convenentesConcedentesConcedido'],
    buscaConvenentesConcedentesConcedidoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaConvenentesConcedentesConcedido = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConvenentesConcedentesConcedidoInicio())
        let serv = new DetalhesRecursoConcedidoService()
        return serv
            .consultarConvenentesConcedentes(filtro)
            .then(response => dispatch(Creators.buscaConvenentesConcedentesConcedidoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConvenentesConcedentesConcedidoErro(error)))
    }
}

const buscaConvenentesConcedentesConcedidoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConvenentesConcedentesConcedidoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConvenentesConcedentesConcedidoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.convenentesConcedentesConcedido, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONVENENTES_CONCEDENTES_CONCEDIDO_INICIO]: buscaConvenentesConcedentesConcedidoInicio,
    [Types.BUSCA_CONVENENTES_CONCEDENTES_CONCEDIDO_ERRO]: buscaConvenentesConcedentesConcedidoErro,
    [Types.BUSCA_CONVENENTES_CONCEDENTES_CONCEDIDO_SUCESSO]: buscaConvenentesConcedentesConcedidoSucesso,
})
